// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2WGux","detailsBorder":"styles_detailsBorder__UjFT5"};